export enum HttpMethod {
  GET = 'onGet',
  POST = 'onPost',
  PUT = 'onPut',
}

export type Response = [HttpMethod, string, number, object?];
